<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-分销-分销设置-基础设置
      -->
  <div class="product-add mt30">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <el-form-item label="是否开启业绩返利">
        <div>
          <el-radio v-model="form.is_groupaward" label="1">开启</el-radio>
          <el-radio v-model="form.is_groupaward" label="0">关闭</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="选择奖励发放等级" v-if="form.is_groupaward">
        <el-select v-model="form.groupaward_grade_ids" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            v-for="item in gradeList"
            :key="item.grade_id"
            :label="item.name"
            :value="item.grade_id">
          </el-option>
        </el-select>
        <div class="gray9">选中的等级用户才能获得奖励</div>
      </el-form-item>
      <el-form-item label="团队业绩返利：" v-if="form.is_groupaward">
        <el-button size="small" class="el-icon-circle-plus" @click="AddPerformance">添加</el-button>
        <table border="0" cellpadding="2" cellspacing="5" class="mt30">
          <tr>
            <th class="tl">业绩(元)</th>
            <th class="tl">返利比例(%)</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in form.performancedata" :key="index">
            <td><el-input size="small" v-model="item.performance" placeholder="请输入门槛参数"></el-input></td>
            <td><el-input size="small" v-model="item.awardRate" placeholder="请输入返利参数"></el-input></td>
            <td><el-button size="small" @click="delPerformance(index)">删除</el-button></td>
          </tr>
        </table>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PlusApi from '@/api/plus.js';

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        is_groupaward: '',
        groupaward_grade_ids: [],
        performancedata: [],
      },
      gradeList: [],
      /*是否正在加载*/
      loading: false
    };
  },
  props:{
    settingData:Object
  },
  created() {
    this.form = this.settingData.data.groupaward.values;
    this.gradeList = this.settingData.gradeList;
  },
  methods: {
    AddPerformance(){
      let self = this;
      let data = {'performance':0,'awardRate':0};
      self.form.performancedata.push(data);
    },
    delPerformance(key){
      let self = this;
      let performancedata = self.form.performancedata;
      let newdata = [];
      performancedata.forEach((item,index)=>{
        if(index != key){
          newdata.push(item);
        }
      });
      self.form.performancedata = newdata;
    },
    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      PlusApi.groupaward(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });

        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/setting/part/Groupaward.vue